import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Button, Dialog } from "@mui/material";
import React from "react";
import {
  InvoiceDialogCloseButton,
  invoiceDesignFontFamily,
  invoiceDesignTokens,
  invoiceDialogPaperSx,
  invoiceModalActionSx,
} from "./InvoiceDesignSystem";

type InvoiceLineItemDeleteDialogProps = Readonly<{
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
}>;

const InvoiceLineItemDeleteDialog = ({
  onCancel,
  onConfirm,
  open,
}: InvoiceLineItemDeleteDialogProps): React.ReactElement => (
  <Dialog
    aria-describedby="invoice-line-item-delete-description"
    aria-labelledby="invoice-line-item-delete-title"
    BackdropProps={{ sx: { backgroundColor: "rgba(10,10,10,0.45)" } }}
    onClose={onCancel}
    open={open}
    PaperProps={{
      sx: {
        ...invoiceDialogPaperSx({ maxWidth: 440 }),
        border: `1px solid ${invoiceDesignTokens.modalBorder}`,
      },
    }}
  >
    <div
      className="relative flex flex-col items-center bg-white px-7 py-[30px] text-center"
      style={{ fontFamily: invoiceDesignFontFamily }}
    >
      <InvoiceDialogCloseButton
        ariaLabel="Close delete line item confirmation"
        onClick={onCancel}
      />

      <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-[#F21B1B] text-white">
        <DeleteOutlineIcon sx={{ fontSize: 30 }} />
      </div>

      <h2
        className="mt-[18px] text-sm font-semibold text-[#0A0A0A]"
        id="invoice-line-item-delete-title"
      >
        Delete Line Item
      </h2>
      <p
        className="mx-auto mt-2 max-w-[340px] text-sm leading-[1.55] text-[#0A0A0A]"
        id="invoice-line-item-delete-description"
      >
        Are you sure you want to delete this line item?
      </p>

      <div className="mt-[22px] flex w-full flex-wrap justify-center gap-3">
        <Button
          onClick={onConfirm}
          startIcon={<DeleteOutlineIcon sx={{ fontSize: 17 }} />}
          sx={{
            ...invoiceModalActionSx({
              backgroundColor: invoiceDesignTokens.closeRed,
              hoverBackgroundColor: "#D90F1A",
            }),
            flex: "1 1 0",
            maxWidth: 170,
          }}
          variant="contained"
        >
          Delete
        </Button>
        <Button
          onClick={onCancel}
          sx={{
            ...invoiceModalActionSx({
              backgroundColor: invoiceDesignTokens.dark,
              hoverBackgroundColor: "#111827",
            }),
            flex: "1 1 0",
            maxWidth: 170,
          }}
          variant="contained"
        >
          Cancel
        </Button>
      </div>
    </div>
  </Dialog>
);

export default InvoiceLineItemDeleteDialog;
